import { useEffect, useMemo, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { useQuery, UseQueryArgs } from 'urql'

export const useInfiniteScroll = (
  paginatorInfoLocation: string,
  query: UseQueryArgs,
) => {
  const [page, setPage] = useState(1)
  const { ref: infiniteScrollRef, inView: isIntersecting } = useInView()

  const [{ data, fetching, operation }, getData] = useQuery({
    query: query.query,
    variables: {
      ...query.variables,
      page: page,
      filters: {
        ...query.variables?.filters,
      },
    },
    pause: query.pause ?? false,
    requestPolicy: query.requestPolicy,
  })

  const paginatorInfo = useMemo(
    () => data
      ? paginatorInfoLocation.split('.').reduce((a, b) => a?.[b], data)
      : null,
    [data, paginatorInfoLocation],
  )

  useEffect(() => {
    if (!fetching
      && isIntersecting
      && paginatorInfo?.hasMorePages
      && paginatorInfo?.currentPage == page
    ) {
      setPage((paginatorInfo?.currentPage ?? 1) + 1)
    }
  }, [
    fetching,
    isIntersecting,
    paginatorInfo?.hasMorePages,
    paginatorInfo?.currentPage,
  ])

  return {
    infiniteScrollRef,
    page,
    setPage,
    data,
    fetching,
    operation,
    getData,
  }
}
